import type { CatalogMetadata } from '../types';

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function downloadText(content: string, filename: string, type = 'application/json') {
  downloadBlob(new Blob([content], { type }), filename);
}

export function metadataJson(catalog: CatalogMetadata) {
  return JSON.stringify(
    {
      title: catalog.title,
      slug: catalog.slug,
      token: catalog.token,
      created: catalog.created,
      updated: catalog.updated,
      pageCount: catalog.pageCount,
      publicUrl: catalog.publicUrl,
      pdfUrl: catalog.pdfUrl ?? '',
      pages: {
        previewPattern: `/catalogs/${catalog.slug}/pages/preview/page-{n}.webp`,
        fullPattern: `/catalogs/${catalog.slug}/pages/full/page-{n}.webp`
      }
    },
    null,
    2
  );
}

export function copyText(value: string) {
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(value);
  }
  const area = document.createElement('textarea');
  area.value = value;
  document.body.appendChild(area);
  area.select();
  document.execCommand('copy');
  area.remove();
  return Promise.resolve();
}
